module.exports = __webpack_public_path__ + "media/《甘肃省“BIM+智慧工地”项目管理平台》宣传片.03607776.mp4";